<template>
  <v-dialog v-model="visible" persistent width="1200">
    <v-card :loading="loading">
      <v-card-title>
        <span class="headline">{{ $t("modal.updateCase.title") }}</span>
      </v-card-title>
      <v-card-text>
        <!-- Update case form -->
        <v-form ref="updateCaseForm">
          <!-- compliance and attributes -->
          <v-row dense>
            <v-col cols="12">
              <v-row align="center">
                <v-col cols="4">
                  <h3>{{ $t("label.compliance") }}</h3>
                </v-col>
                <v-col>
                  <v-divider />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editCase.caseGroupId"
                    :items="caseGroups"
                    :label="$t('modal.addCase.label.caseGroups')"
                    :hint="$t('hint.caseGroups')"
                    persistent-hint
                    item-text="name"
                    item-value="id"
                    dense
                    clearable
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="onCancel">{{
          $t("label.cancel")
        }}</v-btn>
        <v-btn dark color="blue darken-1" @click="onSave" :loading="loading">{{
          $t("label.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getMinDateString } from "../../utils/dateUtils";
export default {
  name: "LimitedEditCase",
  props: {
    caseRecord: {},
    caseGroups: {},
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editCase: {
        ...this.caseRecord,
      },
      loading: false,
      error: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  watch: {
    // This component is never killed/recreated with v-if, so need to listen for prop changes to reset editable case
    caseRecord: function (newCaseRecord) {
      this.editCase = { ...newCaseRecord };
    },
  },
  computed: {
    ...mapGetters(["getProfile"]),
  },
  created() {
    // If this case has attributes, clear default attribute and populate with existing attributes
    // if (
    //   this.selectedCase.caseAttributes &&
    //   Object.keys(this.selectedCase.caseAttributes).length > 0
    // ) {
    //   this.customAttributes = [];
    //   Object.entries(this.selectedCase.caseAttributes).map(([key, value]) => {
    //     this.customAttributes.push({ key: key, value: value });
    //   });
    // }
  },
  methods: {
    ...mapActions(["setGlobalAlert", "updateCase"]),
    getMinDateString,
    //submit - TODO catch error if case group was deleted prior to saving case
    async onSave() {
      if (!this.$refs.updateCaseForm.validate()) {
        return false;
      }

      this.error = null;
      this.loading = true;

      try {
        await this.updateCase(this.editCase);
        this.$emit("onConfirmed");
      this.setGlobalAlert({
        alert: true,
        color: "green",
        alertMessage: "Case Updated",
      });
      } catch (e) {
      this.setGlobalAlert({
        alert: true,
        color: "red",
        alertMessage:
          "Unable to update case record at this time, please try again. ",
      });
      }

      // TODO eventually figure out how to path the record to avoid using update which sets empty fields such as crypto to null in DB
      // var params = {
      //   whitelisted: this.editCase.whitelisted,
      //   whitelistedUntil: this.editCase.whitelistedUntil,
      //   caseGroupId: this.editCase.caseGroupId,
      // };
      // this.patchCases({ ids: [this.editCase.id], params })
      //   .then(() => {
      //     this.$emit("onConfirmed");
      //     this.setGlobalAlert({
      //       alert: true,
      //       color: "green",
      //       alertMessage: "Case Updated",
      //     });
      //   })
      //   .catch(() => {
      //     this.setGlobalAlert({
      //       alert: true,
      //       color: "red",
      //       alertMessage:
      //         "Unable to update case record at this time, please try again. ",
      //     });
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });

      this.loading = false;
    },
    onCancel() {
      this.$emit("onCancelled");
    },
  },
};
</script>